/**
 * RG Reviews Section Script
 * Handles "Buy Now" functionality with direct checkout.
 */

class RGReviewsBuyNow {
    constructor(btn) {
        this.btn = btn;
        this.variantId = this.btn.dataset.buyNow;

        // Debug
        console.log('RGReviews: Init button for variant', this.variantId);

        if (this.variantId) {
            this.init();
        } else {
            console.warn('RGReviews: Button missing data-buy-now ID');
        }
    }

    init() {
        this.btn.addEventListener('click', (e) => this.handleClick(e));
    }

    async handleClick(e) {
        e.preventDefault();
        const btn = this.btn;
        const originalText = btn.innerHTML; // Verify if we use text or HTML

        console.log('RGReviews: Click handling for', this.variantId);

        // UI Loading State
        btn.textContent = 'Procesando...';
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.7';

        // Construct Cart URL safely
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const addUrl = root + 'cart/add.js';

        try {
            const response = await fetch(addUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: this.variantId,
                    quantity: 1
                })
            });

            if (response.ok) {
                console.log('RGReviews: Added to cart, redirecting to checkout...');
                window.location.href = '/checkout';
            } else {
                const errorData = await response.json();
                console.error('RGReviews: Add to cart failed', errorData);

                btn.textContent = 'Agotado / Error';
                // Restore button after delay
                setTimeout(() => {
                    btn.innerHTML = originalText;
                    btn.style.pointerEvents = 'auto';
                    btn.style.opacity = '1';
                }, 2000);
            }
        } catch (error) {
            console.error('RGReviews: Network error', error);
            btn.textContent = 'Error de conexión';
            setTimeout(() => {
                btn.innerHTML = originalText;
                btn.style.pointerEvents = 'auto';
                btn.style.opacity = '1';
            }, 2000);
        }
    }
}

// Initialize on Load
document.addEventListener('DOMContentLoaded', () => {
    initReviewsSection();
});

// Initialize on Theme Editor Load (Design Mode)
document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('rg-reviews-section') || event.target.querySelector('.rg-reviews')) {
        console.log('RGReviews: Section reloaded by editor');
        initReviewsSection();
    }
});

function initReviewsSection() {
    const buyBtns = document.querySelectorAll('.rg-reviews [data-buy-now]');
    console.log('RGReviews: Found buttons', buyBtns.length);
    buyBtns.forEach(btn => new RGReviewsBuyNow(btn));
}
